// extracted by mini-css-extract-plugin
export default {"parent":"RatingCard_parent__odov6","fadeIn":"RatingCard_fadeIn__56fmO","card":"RatingCard_card__3K6Vk"};